<template>
	<div class="communityManagement ">
		<div class="itemTitleBox disStart">
			<span class="title">社区管理</span>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="myinputBox">
					<el-input clearable v-model="searchObj.search" placeholder="请输入社区名称">
					</el-input>
				</div>
				<div class="myinputBox" v-if="!($serviceProviderId)">
					<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
						<el-option v-for="(item,inx) in restaurants" :key="inx" :label="item.serviceProviderName"
							:value="item.serviceProviderId"></el-option>
					</el-select>
				</div>
				<div class="myinputBox">
					<el-cascader clearable ref="cascader1" placeholder="请选择地区"
						:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}" v-model="areaValue"
						:options="areaList" @change="handleChange($event,1)">
					</el-cascader>
				</div>
				<el-button type="success" @click="toSearch">查询</el-button>
			</div>

			<div class="icon_add iconBox" @click="openDia(5)" title="新建社区"></div>
		</div>
		<div class="listBox">
			<div v-if="dataList && dataList.length>0" class="dataListBox">
				<div class="content" v-loading="loading">
					<ul>
						<li class="liItem disBetween" v-for="(item,inx) in dataList" :key="inx"
							:class="{active:active==inx}" @click.stop="choiceCommunity(inx)">
							<div class="itemLeft">
								<div class="item_item disBetween">
									<div class="item1 disStart mainColor" :title="item.communityName">
										<span v-if="item.status==0" class="status"></span>
										<span class="ellipsis">{{item.communityName}}</span>
									</div>
									<div class="item3 ">
										<a href="#" class="ellipsis mainColor"
											:title="item.adress">{{item.provinceName}}{{item.cityName}}{{item.areaName}}</a>
									</div>
									<div class="item1 ">
										<div :title="item.billingType">{{item.billingType == 0?'功率计费':'电量计费'}}</div>
									</div>
								</div>
								<div class="item_item disBetween">
									<div class="item2 disBetween">
										<!-- <span class="itemNum">
											充电站：{{item.communityChargeStationNumber}}
										</span> -->
										<span class="itemNum">
											设备数：{{item.communityEquipmentNumber}}
										</span>
									</div>
									<div class="item3">
										累计营收：{{item.communityRevenue}}元
									</div>
								</div>
							</div>

							<el-popover class="mypopover" placement="bottom-start" width="100" trigger="hover">
								<div class="pupBox">
									<span class="hoverClass" @click.stop="itemClick(item,inx,1)">详情</span>
									<!-- <span class="hoverClass" @click.stop="itemClick(item,inx,2)">营收</span> -->
									<!-- <span class="hoverClass" @click.stop="itemClick(item,inx,3)">配置</span> -->
									<span class="hoverClass" @click.stop="itemClick(item,inx,4)">删除</span>
								</div>
								<div slot="reference" class="itemRight listIcon"></div>
							</el-popover>
						</li>
					</ul>
				</div>

				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
			<div v-else class="nodataBox">
				<nodata :str="str">
					<template v-slot>
						<div class="slotBox">
							<div class="disStart" @click="openDia(5)" title="新建社区">
								<span class="icon_add2"></span>
								<span>新建社区</span>
							</div>
						</div>
					</template>
				</nodata>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="社区名称" prop="name">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.name" placeholder="请输入社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="社区类型" prop="communityTypeId">
								<div class="myinputBox">
									<el-select clearable value-key="communityTypeName"
										v-model="creatObj.communityTypeId" slot="prepend" placeholder="请选择社区类型"
										@change="selectChange">
										<el-option v-for="(item,inx) in typeList" :key="inx"
											:label="item.communityTypeName" :value="item.communityTypeId"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营商" prop="serviceProviderId">
								<div class="myinputBox myinputBox2">
									<el-select clearable value-key="serviceProviderName"
										v-model="creatObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
										<el-option v-for="(item,inx) in restaurants" :key="inx"
											:label="item.serviceProviderName"
											:value="item.serviceProviderId"></el-option>
									</el-select>
								</div>
							</el-form-item>

						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="计费方式" prop="billingType">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.billingType" slot="prepend"
										placeholder="请选择计费类型">
										<el-option v-for="(item,inx) in billingType" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="支付方式" prop="payTypeList">
								<div class="myinputBox myinputBox2">
									<el-select clearable multiple collapse-tags v-model="creatObj.payTypeList"
										slot="prepend" placeholder="请选择支付方式">
										<el-option v-for="(item,inx) in payTypeList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="省市区" prop="areaValue">
								<div class="myinputBox myinputBox2">
									<el-cascader clearable v-model="creatObj.areaValue" ref="cascader2"
										:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}"
										:options="areaList" @change="handleChange($event,2)"></el-cascader>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem  disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="具体地址" prop="adress">
								<div class="myinputBox myinputBox3">
									<el-input clearable id="userInput" @focus='openAdress=true'
										v-model="creatObj.adress" placeholder="请输入具体地址 / 社区名称">
									</el-input>
									<!-- <ul class="adressList" v-if="openAdress">
							 			<li v-for="(item,inx) in poiList" :key="inx" @click="addMarker(item)">
							 				{{item.name}}
							 			</li>
							 		</ul> -->
								</div>
							</el-form-item>
							<span class="getPosition" @click="getPosition">获取经纬度</span>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="经度" prop="lng">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.lng" placeholder="请输入社区经度坐标">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="纬度" prop="lat">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.lat" placeholder="请输入社区纬度坐标">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="disStart">
						<div class="lableBox"></div>
						<div id="mapBox"></div>
					</div>
					<div class="disStart">经纬度：{{creatObj.lng}} , {{creatObj.lat}}</div> -->
				</div>
				<!-- <span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="toSave">保 存</el-button>
				</span> -->
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		getAesKey,
		aesDecrypt,
		aesEncrypt,
		DecryptNode,
		EncryptNode
	} from '../../../../../common/js/secret.js'

	import {
		tipsList,
		tableList
	} from "@/assets/js/data.js"
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		log10
	} from "core-js/library/es6/number";
	import nodata from "../../../nodata/nodata.vue"
	let Amap;
	window._AMapSecurityConfig = {
		securityJsCode: 'fbfe9ed39101632111f069d76bf27a88',
	}
	export default {
		name: "communityManagement",
		components: {
			nodata
		},
		props: {
			areaList: {
				type: Array,
				default: []
			},
			typeList: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
				str: "您还没有相应的社区,请新建社区",
				loading: false,
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				creatObj: {
					name: "",
					type: "",
					adress: "",
					payTypeList: [],
					billingType:[],//计费方式
					communityTypeId: "",
					// 经度
					lng: "",
					// 维度
					lat: ""
				},
				NOfalse: false,
				auto: null,
				placeSearch: null,
				dialogVisible: false,
				searchObj: {
					search: "",
					pageNo: 1, //当前页
					pageSize: 8, //当
					serviceProviderId: "",
					provinceCode: "", //省级编号
					cityCode: "", //市级编号
					areaCode: "" //区级编号
				},
				areaValue: "",
				active: 0,
				city: "",
				poiList: [],
				restaurants: [],
				payTypeList: [{
						text: "微信支付",
						value: 1
					},
					{
						text: "工商银行支付",
						value: 2
					},
				],
				billingType: [{
						text: "功率计费",
						value: 0
					},
					{
						text: "电量计费",
						value: 1
					},
				],
				formShuRuMessage: {},
				dataList: [],
				serviceList: [],
				openAdress: false,
				dialogTitle: "新建社区",
				rules: {
					name: [{
						required: true,
						message: '请输入社区名称',
						trigger: 'blur'
					}],
					communityTypeId: [{
						required: true,
						message: '请选择社区类型',
						trigger: 'change'
					}],
					areaValue: [{
						required: true,
						message: '请选择省市区',
						trigger: 'change'
					}],
					payTypeList: [{
						required: true,
						message: '请选择支付方式',
						trigger: 'change'
					}],
					serviceProviderId: [{
						required: true,
						message: '请选择运营商',
						trigger: 'change'
					}],
					adress: [{
						required: true,
						message: '请输入具体地址',
						trigger: 'change'
					}],
					lng: [{
						required: true,
						message: '请输入经度坐标',
						trigger: 'change'
					}],
					lat: [{
						required: true,
						message: '请输入纬度坐标',
						trigger: 'change'
					}],
					billingType: [{
						required: true,
						message: '请选择计费方式',
						trigger: 'change'
					}]
				},
				
			}
		},
		mounted() {
			this.$nextTick(() => {
				// this.getData()
				this.selectParamConfigByCode()
			})
		},
		watch: {
			userInput(n) {
				let that = this
				if (this.openAdress) {
					// if (n) {
					// 	that.placeSearch.search(n, function(status, result) {
					// 		// 查询成功时，result即对应匹配的POI信息
					// 		console.log(result)
					// 		if(result.poiList){
					// 			console.log(result.poiList.pois)
					// 			that.$set(that, "poiList", result.poiList.pois)
					// 		}else{
					// 			that.$message({
					// 				type:"error",
					// 				message:"使用次数上限"
					// 			})
					// 		}

					// 	});
					// } else {
					// 	that.$set(that, "poiList", [])
					// }
				}
			}
		},
		methods: {
			//调试平台对接，应该是对接南京市充电桩平台
			// getequipmenToken(){
			// 	this.$api.equipmenToken(
			// 	// {
			// 	// 	operatorId:"3201P00001",
			// 	// 	operatorSecret:"5d680749acf94365b8915b5caf19c295"
			// 	// }
			// 	{"OperatorID":"3201P00001","Data":"0PIGb8M1oDaSegrTUbAtb1i5rHIs2pFiajAX2KazChuXMBR2npxJYb39xpXFVHy3732E74jtCLiELuVlnjh80ULhFywKLgmCMMlXR+FwdEM=",
			// 	"TimeStamp":"20250305173347","Seq":"1741167227","Sig":"AA18722FFF9B39C58F5495B1083FDD26"}
			// 	).then((res) => {
			// 		console.log(res,'qqwwee')
			// 	})
			// },
			//调试平台对接,应该是对接南京市充电桩平台
			// getequipmentStatus(){
			// 	this.$api.equipmentStatus(
			// 	{
			// 		EquipmentID: "CE2024041719223080588376"
			// 	}
			// 	// {"OperatorID":"3201P00001","Data":"WAqtTrO5ektwkL22iK1RAkEJkmeZVEwlqOWzFiDITUdf2qnDiGFEX236DYrWk/Wx",
			// 	// "TimeStamp":"20250306141605","Seq":"1741241765","Sig":"77B8AC6C710ABEBDB6D3C9CDFE684E5C"}
			// 	).then((res) => {
			// 		console.log(res,'pprrtt')

			// 	})
			// },
			getPosition() {
				window.open("https://api.map.baidu.com/lbsapi/getpoint/index.html")
			},
			handleSelect(item) {
				this.$set(this.searchObj, "equipmentServiceName", item.value)
				this.$set(this.searchObj, "serviceProviderId", item.id)
			},
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "restaurants", res.obj || [])
					}
				})
				// this.$api.selectParamConfigByCode({
				// 	"paramCode": 1008,
				// 	"search": ""
				// }).then((res) => {
				// 	if (res.returnCode == 200) {
				// 		for (let k in res.obj.paramConfigItemList) {
				// 			res.obj.paramConfigItemList[k].id = k+1
				// 		}
				// 		this.$set(this, "payTypeList", res.obj.paramConfigItemList)
				// 		console.log(this.payTypeList)
				// 	}
				// })

			},
			// 列表弹窗打开  1编辑2营收3配置4删除5新增
			openDia(n, item) {
				if (n == 1) { //详情
					this.dialogTitle = "社区信息"
					this.getCommunityInfo(item.communityId)
				} else if (n == 5) { //新增
					this.dialogTitle = "新建社区"
					this.$set(this, "creatObj", {
						name: "",
						type: "",
						typeId: "",
						adress: "",
						communityTypeId: "",
						serviceProviderId: "",
						areaValue: [],
						// 经度
						lng: "",
						// 维度
						lat: ""
					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
						// this.initMap()
					})
				}

			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.dialogTitle == "新建社区") {
							that.addCommunityInfo()
						} else {
							that.updateCommunityInfo()
						}
					} else {
						return false;
					}
				});
			},
			// 编辑社区请求
			updateCommunityInfo() {
				let obj = {
					communityName: this.creatObj.name, //社区名称
					communityId: this.creatObj.communityId, //社区id
					communityTypeId: this.creatObj.communityTypeId, //社区类型id
					serviceProviderId: this.creatObj.serviceProviderId, //运营商id
					provinceCode: this.creatObj.provinceCode || "", //省级编号
					cityCode: this.creatObj.cityCode || "", //市级编号
					areaCode: this.creatObj.areaCode || "", //区级编号
					payTypeList: this.creatObj.payTypeList || [], //支付方式
					billingType: this.creatObj.billingType,//计费方式
					communityAddress: this.creatObj.adress, //社区地址
					communityLongitude: this.creatObj.lng, //社区经度
					communityLatitude: this.creatObj.lat //社区纬度
				}
				this.$api.updateCommunityInfo(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '社区修改成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData({
									n: 1,
									k: 1
								})
							}, 500)
						})
					}
				})
			},
			// 新增社区请求
			addCommunityInfo() {
				let obj = {
					communityName: this.creatObj.name, //社区名称
					communityTypeId: this.creatObj.communityTypeId, //社区类型id
					serviceProviderId: this.creatObj.serviceProviderId, //运营商id
					provinceCode: this.creatObj.provinceCode || "", //省级编号
					cityCode: this.creatObj.cityCode || "", //市级编号
					areaCode: this.creatObj.areaCode || "", //区级编号
					payTypeList: this.creatObj.payTypeList || [], //支付方式
					billingType: this.creatObj.billingType,//计费方式
					communityAddress: this.creatObj.adress, //社区地址
					communityLongitude: this.creatObj.lng, //社区经度
					communityLatitude: this.creatObj.lat //社区纬度
				}
				this.$api.addCommunityInfo(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新建社区成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData({
									n: 1,
									k: 1
								})
							}, 500)
						})
					}
				})
	
			},
			// 获取社区详情
			getCommunityInfo(id) {
				this.$api.selectCommunityInfo({
					communityId: id
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "creatObj", {
							name: res.obj.communityName,
							typeName: res.obj.communityTypeName,
							communityTypeId: res.obj.communityTypeId,
							serviceProviderId: res.obj.serviceProviderId,
							communityId: id,
							adress: res.obj.communityAddress,
							areaValue: [],
							payTypeList: res.obj.payTypeList,
							billingType:res.obj.billingType,
							provinceCode: res.obj.provinceCode,
							cityCode: res.obj.cityCode,
							areaCode: res.obj.areaCode,
							// 经度
							lng: res.obj.communityLongitude,
							// 维度
							lat: res.obj.communityLatitude
						})
						console.log(this.creatObj.payTypeList)
						if (res.obj.provinceCode) {
							this.creatObj.areaValue.push(res.obj.provinceCode)
							if (res.obj.cityCode) {
								this.creatObj.areaValue.push(res.obj.cityCode)
								if (res.obj.areaCode) {
									this.creatObj.areaValue.push(res.obj.areaCode)
								}
							}
						}
						this.$nextTick(() => {
							this.dialogVisible = true
							// this.initMap()
							this.$refs.ruleForm1.clearValidate()
						})
					}
				})
			},
			// 请选择社区类型
			selectChange(e) {
				let ss = this.typeList.find((item) => {
					return item.id == e
				})
				if (ss) {
					this.creatObj.typeName = ss.communityTypeName
					this.creatObj.typeId = ss.id
				} else {
					this.creatObj.typeName = ''
					this.creatObj.typeId = ''
				}

			},
			addMarker(obj) {
				this.openAdress = false
				this.creatObj.name = obj.name
				this.$set(this, "poiList", [])
				this.creatObj.lng = obj.location.lng
				this.creatObj.lat = obj.location.lat
				this.map.setCenter([obj.location.lng, obj.location.lat])
				this.map.clearMap();
				var marker = new Amap.Marker({
					position: [obj.location.lng, obj.location.lat], //定义图标的位置
					offset: new Amap.Pixel(0, 0), //设置图标偏移量
					// icon: icons, //自定义图标路径
					draggable: false, //是否可以拖拽
					// cursor: 'move', //方式移动
				});
				//设置文本
				marker.setLabel({
					direction: 'top',
					offset: new AMap.Pixel(0, -10), //设置文本标注偏移量
					content: `<div class="infoShow">
								  <p class="address">${this.creatObj.name}</p>
								</div>`, //设置文本标注内容
				});
				this.map.add(marker); //往地图上添加标注
			},
			initMap() {
				let that = this;
				AMapLoader.load({
					key: '2d6486ec1e527d7e0597a7e73089a11b',
					version: '2.0',
					plugins: ['AMap.AutoComplete', 'AMap.PlaceSearch'],
					// ['AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.AutoComplete','AMap.PositionPicker'],
				}).then(AMap => {
					Amap = AMap;
					that.map = new AMap.Map('mapBox', {
						// resizeEnable: true,
						center: ['106.901367', '34.905904'],
						zoom: 12, //初始化地图级别
					})
					//引入高德地图的空间绑定使用
					that.auto = new AMap.AutoComplete({
						input: 'userInput', //绑定的搜索关键字的input标签ID，用这个注册
						city: ""
					})
					this.auto.on("select", this.select)
					// 注册placeSearch组件
					// that.placeSearch = new AMap.PlaceSearch({
					// 	// city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
					// 	city: '北京'
					// })
					// that.placeSearch = new AMap.PlaceSearch({
					// 	// map: that.map,
					// 	pageSize: 20,
					// 	pageIndex: 1, //请求页码，默认1
					// 	citylimit: false,
					// 	city: that.city,
					// }) 
					if (that.creatObj.lng && that.creatObj.lng) {
						let obj = {
							location: {
								lng: that.creatObj.lng,
								lat: that.creatObj.lat,

							},
							name: that.creatObj.name,
							adress: that.creatObj.adress
						}

						that.addMarker(obj)
					}

				})
			},
			select(e) {
				this.addMarker(e.poi)
				// this.placeSearch.setCity(e.poi.adcode)
				// this.placeSearch.search(e.poi.name) //关键字查询查询
			},
			toSearch() {
				this.active = 0
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.getData({
					n: 1,
					k: 1
				})
			},
			// 获取社区列表
			getData(obj) {
				// console.log(obj)
				this.loading = true
				if (obj.n) {
					// this.searchObj.pageNo = obj.n
				}
				// console.log(this.searchObj,3535353)//这里获取社区列表时是带serviceProviderId(运营商ID)的，后台应该没有做处理，直接展示了信息
				this.$api.listCommunityInfo(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "dataList", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						if (obj.k) {
							// 获取充电站
							if (obj.communityId) {
								this.$emit('moduleOne', obj)
							} else {
								if (res.obj.list.length > 0) {
									this.$emit('moduleOne', this.dataList[0])
									this.$emit('moduleTwo', this.dataList[0])
								}

							}

						}
					}
				})


			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData({
					n: val,
					k: 1
				})
			},
			// 信息1营收2配置3删除4
			itemClick(item, inx, n) {
				let that = this
				if (n == 1) {
					this.openDia(n, item)
				} else if (n == 2) {

				} else if (n == 3) {

				} else if (n == 4) {
					this.$confirm('是否确认删除该社区?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteCommunityInfo({
							communityId: item.communityId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData({
										n: 1,
										k: 1
									})
								}, 500)
							}
						})

					}).catch(() => {

					});
				}
			},
			// 选择社区
			choiceCommunity(inx) {
				this.active = inx
				this.$emit('moduleOne', this.dataList[inx])
				this.$emit('moduleTwo', this.dataList[inx])
			},
			// 省市区联动
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					if (n == 1) {
						this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
						this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
						this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
					} else {
						this.$set(this.creatObj, "provinceCode", nodesInfo[0].path[0] || "")
						this.$set(this.creatObj, "cityCode", nodesInfo[0].path[1] || "")
						this.$set(this.creatObj, "areaCode", nodesInfo[0].path[2] || "")
					}
				} else {
					this.$set(this.searchObj, "provinceCode", "")
					this.$set(this.searchObj, "cityCode", "")
					this.$set(this.searchObj, "areaCode", "")
					this.$set(this.creatObj, "provinceCode", "")
					this.$set(this.creatObj, "cityCode", "")
					this.$set(this.creatObj, "areaCode", "")
				}

			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./communityManagement.scss"
</style>